import Vue from 'vue'
import PlanetToast from '@/components/PlanetToast.vue'

let instance = null

function getInstance () {
  if (instance) return instance

  const ToastConstructor = Vue.extend(PlanetToast)
  instance = new ToastConstructor({
    el: document.createElement('div'),
    propsData: {}
  })

  document.body.appendChild(instance.$el)
  return instance
}

function open (type, message, options = {}) {
  const vm = getInstance()

  const finalType = type || 'info'
  const { duration } = options

  vm.type = finalType
  vm.message = message || ''
  if (typeof duration === 'number') {
    vm.duration = duration
  }

  // 直接控制内部可见状态
  vm.internalVisible = true
}

const PlanetNotifyPlugin = {
  install (Vue) {
    const api = {
      info (message, options) {
        open('info', message, options)
      },
      success (message, options) {
        open('success', message, options)
      },
      warning (message, options) {
        open('warning', message, options)
      },
      error (message, options) {
        open('error', message, options)
      }
    }

    // 全局挂载到 Vue 原型，组件内通过 this.$planetNotify 调用
    Vue.prototype.$planetNotify = api
    // 同时挂到构造函数上，必要时可在非实例模块中通过 Vue.$planetNotify 使用
    Vue.$planetNotify = api
  }
}

export default PlanetNotifyPlugin
